<script setup lang="ts">
import { Popover, PopoverButton, PopoverOverlay, PopoverPanel } from '@headlessui/vue';
import { mdiClose, mdiMenu } from '@mdi/js';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import { employeeListAction } from '@/actions/employee';
import { foremanListAction } from '@/actions/foreman';
import { hardwareListAction } from '@/actions/hardware';
import { movementListAction } from '@/actions/movement';
import { projectListAction } from '@/actions/project';
import AppMainMenuItem from '@/components/core/layout/AppMainMenuItem.vue';
import UiIcon from '@/components/core/UiIcon.vue';
import UiTouchButton from '@/components/core/UiTouchButton.vue';
import { useSessionStore } from '@/stores/session';
import AppAction from '@/models/core/AppAction';

const sessionStore = useSessionStore();
const { displayEmployee } = storeToRefs(sessionStore);

const menuItems = computed(() => {
  // Don't show menu items if user is not properly loaded
  if (!displayEmployee.value) {
    return [];
  }

  const items: AppAction[] = [movementListAction(), projectListAction(), hardwareListAction(), foremanListAction(), employeeListAction()];

  // Filter out items that are not allowed to be displayed
  return items.filter((item) => item.allowed !== false);
});
</script>

<template>
  <Popover v-slot="{ open, close }">
    <PopoverButton :as="UiTouchButton" :active="open">
      <UiIcon :path="open ? mdiClose : mdiMenu" />
    </PopoverButton>
    <Transition name="vfm-fade">
      <PopoverOverlay class="ui-bg-overlay max-desktop:landscape:top-0 max-desktop:landscape:left-24 fixed inset-0 top-24" />
    </Transition>
    <Transition name="vfm-fade">
      <PopoverPanel
        class="ui-bg-primary max-desktop:grid max-desktop:grid-cols-2 desktop:right-auto desktop:bottom-0 desktop:left-0 desktop:space-y-2 desktop:shadow-lg max-desktop:landscape:left-24 max-desktop:landscape:top-0 max-desktop:landscape:pl-0 max-desktop:landscape:pt-2 fixed inset-0 top-24 gap-2 p-2 pt-0"
      >
        <AppMainMenuItem v-for="action in menuItems" :key="action.name" :action="action" @click="close" />
      </PopoverPanel>
    </Transition>
  </Popover>
</template>
